// Formatting helpers for the Sales Report. All figures render in JetBrains Mono
// at the component level via the `font-['JetBrains_Mono']` utility.

const SYMBOL: Record<string, string> = { EUR: '€', USD: '$' }

export function symbol(currency: string): string {
  return SYMBOL[currency] ?? ''
}

/** Full grouped figure, e.g. €273,385 */
export function fmt(amount: number, currency: string): string {
  return symbol(currency) + Math.round(amount).toLocaleString('en-US')
}

/** Compact figure for axes/bars, e.g. €531k or €1.3M */
export function fmtCompact(amount: number, currency: string): string {
  const s = symbol(currency)
  const abs = Math.abs(amount)
  if (abs >= 1_000_000) return s + (amount / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M'
  if (abs >= 1_000) return s + Math.round(amount / 1_000) + 'k'
  return s + Math.round(amount)
}

/** Percentage change of curr vs prev. */
export function pctDelta(curr: number, prev: number): number {
  if (!prev) return 0
  return ((curr - prev) / prev) * 100
}

/** Signed percentage label, e.g. +5.8% */
export function fmtPct(p: number): string {
  return (p > 0 ? '+' : '') + p.toFixed(1) + '%'
}

/** "May-26" -> "May 2026". Falls back to the raw label if it doesn't parse. */
export function monthLabel(code: string): string {
  const [mon, yy] = code.split('-')
  if (!mon || !yy) return code
  return `${mon} 20${yy}`
}

/** Tailwind utility to render figures in JetBrains Mono with tabular alignment. */
export const MONO = "font-['JetBrains_Mono'] tabular-nums"
